import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as thunks from 'features/thunks'
import ProcessedBranding from './processed-branding-model'
import {
  CreateProcessedBrandingAsync,
  DeleteProcessedBrandingAsync,
  LoadProcessedBrandingsAsync,
} from './processedBranding-thunk'
const initialState: processedBrandingSliceState = {
  processedBranding: [],
  selected_processedBranding: '',
  is_loading_processedBranding: false,
  is_creating_processedBranding: false,
  is_deleting_processedBranding: false,
}
export interface processedBrandingSliceState {
  processedBranding: ProcessedBranding[]
  selected_processedBranding?: string
  is_loading_processedBranding: boolean
  is_creating_processedBranding: boolean
  is_deleting_processedBranding: boolean
}
export const processedBrandingSlice = createSlice({
  name: 'processedBranding',
  initialState,
  reducers: {
    setSelectedprocessedBranding: (state, action) => {
      state.selected_processedBranding = action.payload
    },
    clearStateprocessedBranding: (state) => {
      state.processedBranding = []
      state.is_loading_processedBranding = false
      state.is_creating_processedBranding = false
      state.is_deleting_processedBranding = false
    },
    mergeprocessedBranding: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processedBranding = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processedBranding = merge(
            state.processedBranding,
            payload,
          ) as any
        }
      }
    },

    add_processedBranding: (state, action) => {
      if (action.payload) {
        state.processedBranding = [...state.processedBranding, action.payload]
      }
    },
    set_processedBranding: (state, action) => {
      let { key, value, id } = action.payload
      state.processedBranding = state.processedBranding.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      thunks.SetProcessedBrandingReleasedAsync.pending,
      (state) => {
        state.is_loading_processedBranding = true
      },
    )
    builder.addCase(
      thunks.SetProcessedBrandingReleasedAsync.fulfilled,
      (state, action) => {
        state.is_loading_processedBranding = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      thunks.SetProcessedBrandingReleasedAsync.rejected,
      (state) => {
        state.is_loading_processedBranding = false
      },
    )

    builder.addCase(
      thunks.DeleteProcessedBrandingReleasedAsync.pending,
      (state) => {
        state.is_loading_processedBranding = true
      },
    )
    builder.addCase(
      thunks.DeleteProcessedBrandingReleasedAsync.fulfilled,
      (state, action) => {
        state.is_loading_processedBranding = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      thunks.DeleteProcessedBrandingReleasedAsync.rejected,
      (state) => {
        state.is_loading_processedBranding = false
      },
    )

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessedBrandingsAsync.pending, (state) => {
      state.is_loading_processedBranding = true
    })
    builder.addCase(LoadProcessedBrandingsAsync.fulfilled, (state, action) => {
      state.is_loading_processedBranding = false
      if (action.payload) {
        state.processedBranding = action.payload
      }
    })
    builder.addCase(LoadProcessedBrandingsAsync.rejected, (state) => {
      state.is_loading_processedBranding = false
    })
    builder.addCase(CreateProcessedBrandingAsync.pending, (state) => {
      state.is_creating_processedBranding = true
    })
    builder.addCase(CreateProcessedBrandingAsync.fulfilled, (state) => {
      state.is_creating_processedBranding = false
    })
    builder.addCase(CreateProcessedBrandingAsync.rejected, (state) => {
      state.is_creating_processedBranding = false
    })
    builder.addCase(DeleteProcessedBrandingAsync.pending, (state) => {
      state.is_deleting_processedBranding = true
    })
    builder.addCase(DeleteProcessedBrandingAsync.fulfilled, (state, action) => {
      state.is_deleting_processedBranding = false
      if (state.processedBranding) {
        state.processedBranding = state.processedBranding.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProcessedBrandingAsync.rejected, (state) => {
      state.is_deleting_processedBranding = false
    })
  },
})

function handleResult(action: any, state: processedBrandingSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_processedBranding = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.processedBranding = merge(state.processedBranding, payload) as any
    }
  }
}

export const {
  clearStateprocessedBranding,
  setSelectedprocessedBranding,
  set_processedBranding,
  mergeprocessedBranding,
  add_processedBranding,
} = processedBrandingSlice.actions

export const get_processedBranding =
  (id?: string) =>
  (state: {
    processedBranding: {
      processedBranding: ProcessedBranding[]
    }
  }): ProcessedBranding | null => {
    let temp = state?.processedBranding?.processedBranding?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.processedBranding?.processedBranding[0] || null
  }
export const get_selected_processedBranding = (state: {
  processedBranding: processedBrandingSliceState
}): ProcessedBranding | null => {
  let id = state?.processedBranding?.selected_processedBranding
  let temp = state?.processedBranding?.processedBranding?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processedBranding = (state: {
  processedBranding: {
    processedBranding: ProcessedBranding[]
  }
}): ProcessedBranding[] => {
  let temp = state?.processedBranding?.processedBranding
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processedBranding_busy = (state: {
  processedBranding: processedBrandingSliceState
}) => {
  return (
    state?.processedBranding.is_deleting_processedBranding ||
    state?.processedBranding.is_loading_processedBranding ||
    state?.processedBranding.is_creating_processedBranding
  )
}
export const is_deleting_processedBranding_busy = (state: {
  processedBranding: processedBrandingSliceState
}) => {
  return state?.processedBranding.is_deleting_processedBranding
}
export const is_loading_processedBranding_busy = (state: {
  processedBranding: processedBrandingSliceState
}) => {
  return state?.processedBranding.is_loading_processedBranding
}
export const is_creating_processedBranding_busy = (state: {
  processedBranding: processedBrandingSliceState
}) => {
  return state?.processedBranding.is_creating_processedBranding
}

export default processedBrandingSlice.reducer
